import { Button } from '@src/components/Button';
import { ButtonType } from '@src/types';
import { IconType } from '@src/IconType';
import { JobImportModal } from '../modals/JobImportModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ImportButton() {
  const { t } = useTranslation('jobWizard', { keyPrefix: 'importAlert' });
  const [importModalOpen, setImportModalOpen] = useState(false);

  return (
    <>
      <Button
        buttonType={ButtonType.SECONDARY_BLUE}
        label={t('button.label')}
        IconLeading={IconType.AI}
        onClick={() => setImportModalOpen(true)}
        data-testid="import-button"
        className="!hidden sm:!inline-flex"
      ></Button>
      <JobImportModal open={importModalOpen} setOpen={setImportModalOpen} />
    </>
  );
}
